import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { api } from '@/api'
import type { Reward, User } from '@/interfaces/user.interface'
import type { Farming } from '@/interfaces/farming.interface'
import { analyticsService } from '@/services/analytics.service'
export const useUserStore = defineStore('user', () => {
  const user = ref<User>()
  const streakDays = computed(() => user.value?.session[0].streak_days)
  const lastSessionDay = computed(() => user.value?.session[0].last_day || '')
  const farming = ref<Farming | null>()
  const reward = ref<Reward>()

  const taps = ref(0)

  const startTapSync = () => {
    window.setInterval(() => {
      syncTaps()
    }, 6000)
  }

  startTapSync()

  const fetchUser = async () => {
    user.value = await api.user()
  }

  const getFarming = async () => {
    farming.value = (await api.farming.get()).farming
  }

  const startFarming = async () => {
    const response = await api.farming.start()
    if (response.status === 'success') {
      farming.value = response.farming
      analyticsService.logStartFarming()
    }
    return response
  }

  const stopFarming = async () => {
    farming.value = null
    const response = await api.farming.stop()
    if (response.status === 'success') {
      analyticsService.logStopFarming()
    }
    if (response.balance) user.value!.balance = BigInt(response.balance) + BigInt(taps.value)
    await getFarming()
    return response
  }

  const triggerVisit = async () => {
    reward.value = await api.visit()
  }

  const claimReferral = async () => {
    const { balance } = await api.claimReferral()
    user.value!.balance = balance
    user.value!.referral_balance = '0'
  }

  const addTap = () => {
    user.value!.balance = BigInt(user.value!.balance) + 1n
    taps.value++
    if (taps.value > 100) {
      syncTaps()
    }
  }

  const syncTaps = async () => {
    if (taps.value === 0) return

    const count = taps.value
    taps.value = 0
    const response = await api.syncTaps({ payload: { taps: count } })
    user.value!.balance = BigInt(response.balance) + BigInt(taps.value)
  }

  return {
    user,
    streakDays,
    lastSessionDay,
    farming,
    reward,
    fetchUser,
    getFarming,
    startFarming,
    stopFarming,
    claimReferral,
    triggerVisit,
    addTap
  }
})
